module.exports = __webpack_public_path__ + "e199b6e1e49d54e70875af4c6e156cbb.jpg";